"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remainingEffortReportInputSchema = exports.remainingEffortReportSchema = exports.workPackageInputSchema = exports.workPackageSchema = exports.workPackageStatusSchema = exports.WORK_PACKAGE_STATUSES = void 0;
const zod_1 = require("zod");
const common_js_1 = require("./common.js");
const organisation_js_1 = require("./organisation.js");
exports.WORK_PACKAGE_STATUSES = ['offen', 'in_arbeit', 'kritisch', 'abgeschlossen'];
exports.workPackageStatusSchema = zod_1.z.enum(exports.WORK_PACKAGE_STATUSES);
exports.workPackageSchema = zod_1.z.strictObject({
    id: common_js_1.idSchema,
    tenantId: organisation_js_1.tenantSchema.shape.id,
    projectId: common_js_1.idSchema,
    templateId: common_js_1.idSchema.nullable(),
    name: common_js_1.textSchema,
    fachgruppeId: common_js_1.idSchema,
    leistungsphase: common_js_1.leistungsphaseSchema,
    assignedEmployeeId: common_js_1.idSchema.nullable(),
    planHours: common_js_1.hoursSchema,
    deadline: common_js_1.dateSchema.nullable(),
    status: exports.workPackageStatusSchema,
    version: zod_1.z.number().int().nonnegative(),
});
exports.workPackageInputSchema = exports.workPackageSchema
    .pick({
    projectId: true,
    name: true,
    fachgruppeId: true,
    leistungsphase: true,
    assignedEmployeeId: true,
    planHours: true,
    deadline: true,
})
    .extend({ templateId: common_js_1.idSchema.optional() });
// `WorkPackageTemplate` (AC-015) ist mit AC-301 durch die Arbeitspaket-Bibliothek
// ersetzt (`work-package-library.ts`): Gewerk statt Fachgruppe, Leistungsphasen
// statt einer Phase (Entscheidungen H1, H2). `templateId` oben bleibt die Herkunft
// einer Instanz; ihre Anbindung an `work_package_library` ist AC-303.
/** Each report is a new estimate; no input schema can identify an existing row to overwrite. */
const remainingEffortReportBaseSchema = zod_1.z.strictObject({
    id: common_js_1.idSchema,
    tenantId: organisation_js_1.tenantSchema.shape.id,
    workPackageId: common_js_1.idSchema,
    employeeId: common_js_1.idSchema,
    estimatedRemainingHours: common_js_1.hoursSchema,
    completionPercent: common_js_1.percentageSchema,
    isoYear: common_js_1.isoYearSchema,
    isoWeek: common_js_1.isoWeekSchema,
    reportedAt: common_js_1.timestampSchema,
});
exports.remainingEffortReportSchema = remainingEffortReportBaseSchema.refine(common_js_1.isValidIsoWeek, {
    message: 'ISO week does not exist in this year',
    path: ['isoWeek'],
});
exports.remainingEffortReportInputSchema = remainingEffortReportBaseSchema
    .pick({
    workPackageId: true,
    estimatedRemainingHours: true,
    completionPercent: true,
    isoYear: true,
    isoWeek: true,
})
    .refine(common_js_1.isValidIsoWeek, {
    message: 'ISO week does not exist in this year',
    path: ['isoWeek'],
});
//# sourceMappingURL=work-packages.js.map